import api from "../apps/api/v2/api"
import SpeakAudioForm from "../apps/api/v2/forms/speak_audio"

export const SPEAK_REGEX = /(<audio\s*.*>(.*\n*.*\n*)*<\/audio>)/i

export const SPEAK_LANG_REGEX = /(lang='*.*')/i

const DEFAULT_SOURCE_AUDIO = "https://s3.ap-northeast-1.amazonaws.com/qbase-feature/speak_audio/12345.c7d3cdd1-28d1-4d22-ab77-5385852749f6.mp3"

export function processAudioSpeak(parent: Document | Element = document, loadWhenPlay = false) {
    const elements = Array.from(parent.getElementsByTagName('audio'))

    const speakAutioEletmens: HTMLAudioElement[] = []
    elements.forEach(element => {
        if (processAudioSpeakElement(element, loadWhenPlay)) {
            speakAutioEletmens.push(element)
        }
    })
}

function processAudioSpeakElement(element: HTMLAudioElement, loadWhenPlay = false) {
    const type = element.getAttribute("type")

    if (type != "speak") {
        return false;
    }

    if (element.src) {
        return false;
    }
    const speakAudioForm = new SpeakAudioForm();

    // https://www.geeksforgeeks.org/how-to-strip-out-html-tags-from-a-string-using-javascript/
    var div = document.createElement("div");
    div.innerHTML = element.innerHTML;
    speakAudioForm.content = (div.textContent || div.innerText || "").trim();

    speakAudioForm.lang = element.getAttribute("lang");
    speakAudioForm.voice = element.getAttribute("voice");
    speakAudioForm.speed = element.getAttribute("speed");

    if (loadWhenPlay) {
        // Playクリックするときに、本物を取りに行くので、さきにデフォルトAudioをださないといけない
        element.src = DEFAULT_SOURCE_AUDIO;
        element.onplay = async () => {
            if (element.src == DEFAULT_SOURCE_AUDIO) {
                await loadAudio(element, speakAudioForm)
                element.play()
            }
        }
    } else {
        loadAudio(element, speakAudioForm)
    }
    return true
}

// API Call Here
async function loadAudio(element: HTMLAudioElement, speakAudioForm: SpeakAudioForm) {
    const payload = showLoading(element)
    await api.speakAudio.create(speakAudioForm).then((audioSrc) => {
        hideLoading(payload)
        element.src = audioSrc
        element.load()
    }).catch(()=>{
        hideLoading(payload)
        alert("不明エラー発生しました")
    })
}


function showLoading(element: HTMLAudioElement): {loadingElm: HTMLElement, parent: HTMLElement, root: HTMLElement} {
    // Reset URL audio
    element.src = "";

    const parent = element.parentElement
    const root = parent.parentElement

    // Loading Settup
    const loadingElm = document.createElement("div")
    loadingElm.innerHTML = `
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                `;

    loadingElm.style.position = "absolute";
    loadingElm.style.top = "10px";
    loadingElm.style.left = "calc(50% - 16px)";
    
    // Add Loading into Root
    (root as any).append(loadingElm)

    // Parrent set opacity
    parent.style.opacity = "0.1"

    return {
        loadingElm,
        parent,
        root
    }
}

function hideLoading(payload: {loadingElm: HTMLElement, parent: HTMLElement, root: HTMLElement}) {
    payload.root.removeChild(payload.loadingElm)

    payload.parent.style.opacity = "1"
}